import { Switch } from 'react-aria-components';
import classNames from 'classnames';

import * as styles from './ToggleSwitch.css';

export interface ToggleSwitchProps {
  isSelected?: boolean;
  onChange?: (isSelected: boolean) => void;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
  baseClassName?: string;
  indicatorClassName?: string;
  size?: styles.ToggleSwitchSize;
  children?: React.ReactNode;
}

export function ToggleSwitch({
  isSelected,
  onChange,
  ariaLabel,
  ariaLabelledBy,
  ariaDescribedBy,
  baseClassName,
  indicatorClassName,
  size = '48px',
  children,
}: ToggleSwitchProps) {
  return (
    <Switch
      className={classNames(styles.baseSwitch, baseClassName)}
      isSelected={isSelected}
      onChange={onChange}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
    >
      {children}
      <div
        className={classNames(styles.switchIndicator, indicatorClassName)}
        {...styles.dataSize.props(size)}
      />
    </Switch>
  );
}
